import { render, staticRenderFns } from "./BandejaInterconsulta.vue?vue&type=template&id=0be21d0d&scoped=true"
import script from "./BandejaInterconsulta.vue?vue&type=script&lang=js"
export * from "./BandejaInterconsulta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be21d0d",
  null
  
)

export default component.exports